import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ChevronLeft } from 'lucide-react';

export default function CookiePolicy() {
  const { language } = useApp();

  // Set page title
  useEffect(() => {
    document.title = language === 'tr'
      ? 'Çerez Politikası | Kastamonu Amorium Hotel'
      : 'Cookie Policy | Kastamonu Amorium Hotel';
  }, [language]);

  return (
    <div style={{ minHeight: '100vh', background: '#F6F1E7' }}>
      <Navbar />
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem 1.5rem' }}>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#6E7F5B', textDecoration: 'none', marginBottom: '2rem' }}>
          <ChevronLeft size={14} /> {language === 'tr' ? 'Ana Sayfaya Dön' : 'Back to Home'}
        </Link>

        {language === 'tr' ? (
          <div>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '36px', fontWeight: 600, color: '#1F3A2E', marginBottom: '8px' }}>Çerez Politikası</h1>
            <p style={{ fontSize: '13px', color: '#6E7F5B', marginBottom: '2.5rem' }}>Son güncelleme: Mayıs 2025</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', fontSize: '15px', lineHeight: '1.8', color: '#3A3632' }}>
              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>1. Çerez Nedir?</h2>
                <p>Çerezler, web sitemizi ziyaret ettiğinizde tarayıcınıza kaydedilen küçük metin dosyalarıdır. Site deneyiminizi iyileştirmek ve tercihlerinizi hatırlamak için kullanılmaktadır.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>2. Kullandığımız Çerezler</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {[
                    { type: 'Zorunlu Çerezler', desc: 'Sitenin düzgün çalışması için gereklidir. Dil tercihi, rezervasyon oturumu gibi temel işlevler için kullanılır.' },
                    { type: 'Tercih Çerezleri', desc: 'Dil ve para birimi gibi tercihlerinizi hatırlamak için kullanılır.' },
                    { type: 'Performans Çerezleri', desc: 'Sitenin nasıl kullanıldığını anlamamıza yardımcı olur. Kişisel bilgi içermez.' },
                  ].map(item => (
                    <div key={item.type} style={{ background: 'white', border: '1px solid #EFE7DA', borderRadius: '10px', padding: '14px 18px' }}>
                      <p style={{ fontWeight: 700, color: '#1F3A2E', marginBottom: '4px' }}>{item.type}</p>
                      <p style={{ color: '#5A5450', fontSize: '14px' }}>{item.desc}</p>
                    </div>
                  ))}
                </div>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>3. Çerezleri Kontrol Etme</h2>
                <p>Tarayıcınızın ayarlarından çerezleri silebilir veya devre dışı bırakabilirsiniz. Ancak bazı çerezleri devre dışı bırakmak sitenin bazı özelliklerini etkileyebilir.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>4. Üçüncü Taraf Çerezleri</h2>
                <p>Ödeme işlemleri için kullandığımız TEB Sanal POS ve güvenli bağlantı altyapısı kendi çerez politikalarına sahiptir.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>5. İletişim</h2>
                <p>Çerez politikamız hakkında sorularınız için:<br />
                  📧 <a href="mailto:info@amoriumhotel.com" style={{ color: '#B08D57' }}>info@amoriumhotel.com</a>
                </p>
              </section>
            </div>
          </div>
        ) : (
          <div>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '36px', fontWeight: 600, color: '#1F3A2E', marginBottom: '8px' }}>Cookie Policy</h1>
            <p style={{ fontSize: '13px', color: '#6E7F5B', marginBottom: '2.5rem' }}>Last updated: May 2025</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', fontSize: '15px', lineHeight: '1.8', color: '#3A3632' }}>
              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>1. What Are Cookies?</h2>
                <p>Cookies are small text files saved to your browser when you visit our website. They are used to improve your site experience and remember your preferences.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>2. Cookies We Use</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {[
                    { type: 'Essential Cookies', desc: 'Required for the site to function properly. Used for basic functions such as language preference and reservation session.' },
                    { type: 'Preference Cookies', desc: 'Used to remember your preferences such as language and currency.' },
                    { type: 'Performance Cookies', desc: 'Help us understand how the site is used. Does not contain personal information.' },
                  ].map(item => (
                    <div key={item.type} style={{ background: 'white', border: '1px solid #EFE7DA', borderRadius: '10px', padding: '14px 18px' }}>
                      <p style={{ fontWeight: 700, color: '#1F3A2E', marginBottom: '4px' }}>{item.type}</p>
                      <p style={{ color: '#5A5450', fontSize: '14px' }}>{item.desc}</p>
                    </div>
                  ))}
                </div>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>3. Managing Cookies</h2>
                <p>You can delete or disable cookies from your browser settings. However, disabling some cookies may affect certain features of the site.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>4. Third-Party Cookies</h2>
                <p>TEB Virtual POS, used for payment processing, and our secure connection infrastructure have their own cookie policies.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>5. Contact</h2>
                <p>For questions about our cookie policy:<br />
                  📧 <a href="mailto:info@amoriumhotel.com" style={{ color: '#B08D57' }}>info@amoriumhotel.com</a>
                </p>
              </section>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
